module.exports = __webpack_public_path__ + "static/media/netflix.27e9ac39.svg";